import { Component, Vue, Watch } from 'vue-property-decorator';
import { appModule, DeviceType } from '@/store/modules/ModuleApp';

/** width */
// refer to Bootstrap's responsive design
const WIDTH: any = 992;

@Component({
	name: 'ResizeMixin'
})
/** docs */
export default class extends Vue {
	/** document hooks */
	public get device(): any {
		return appModule.device;
	}

	/** document hooks */
	public get sidebar(): any {
		return appModule.sidebar;
	}

	/** document hooks */
	@Watch('$route')
	private onRouteChange(): any {
		if (this.device === DeviceType.Mobile && this.sidebar.opened) {
			appModule.closeSideBar(false);
		}
	}

	/** document hooks */
	public beforeMount(): any {
		window.addEventListener('resize', this.resizeHandler.bind(this));
	}

	/** document hooks */
	public mounted(): any {
		const isMobile: any = this.isMobile();

		if (isMobile) {
			appModule.toggleDevice(DeviceType.Mobile);
			appModule.closeSideBar(true);
		}
	}

	/** document hooks */
	public beforeDestroy(): any {
		window.removeEventListener('resize', this.resizeHandler.bind(this));
	}

	/** document hooks */
	private isMobile(): any {
		const rect: any = document.body.getBoundingClientRect();

		return rect.width - 1 < WIDTH;
	}

	/** document hooks */
	private resizeHandler(): any {
		if (!document.hidden) {
			const isMobile: any = this.isMobile();

			appModule.toggleDevice(isMobile ? DeviceType.Mobile : DeviceType.Desktop);
			if (isMobile) {
				appModule.closeSideBar(true);
			}
		}
	}
}
